<template>
  <div>
    <div
      v-show="showNotification === 'today'"
      class="alert mb-4 block rounded border-[#ffeeba] bg-[#fff3cd] text-center text-[#856404]"
    >
      <FontAwesomeIcon
        :icon="faTriangleExclamation"
        class="fa-fw inline pr-2"
      />
      本日締め切り！
    </div>
    <div
      v-show="showNotification === 'aLittleLeft'"
      class="alert mb-4 block rounded border-[#ffeeba] bg-[#fff3cd] text-center text-[#856404]"
    >
      <FontAwesomeIcon
        :icon="faTriangleExclamation"
        class="fa-fw inline pr-2"
      />
      残りわずか！
    </div>
  </div>
</template>

<script lang="ts">
import { defineNuxtComponent } from '#app'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faTriangleExclamation } from '@awesome.me/kit-65d95819ce/icons/classic/solid'

const options = {
  async setup() {
    return {
      faTriangleExclamation,
    }
  },
  props: {
    latestCohort: {
      type: Object,
      default: null,
    },
  },
  computed: {
    closesAt() {
      return this.latestCohort
        ? new Date(this.latestCohort.attributes.closes_at)
        : null
    },
    showNotification() {
      if (this.closesAt) {
        const now = new Date()
        const leftDays =
          (this.closesAt.valueOf() - now.valueOf()) / (1000 * 60 * 60 * 24)
        if (leftDays > 0 && leftDays < 1) {
          return 'today'
        } else if (leftDays > 1 && leftDays < 3) {
          return 'aLittleLeft'
        } else {
          return null
        }
      } else {
        return null
      }
    },
  },
  components: {
    FontAwesomeIcon,
  },
}

export default defineNuxtComponent(options)
</script>
